import React, { FC } from 'react';
import { TimifyLogo } from 'components/ui';
import routesByName from 'constants/routes';
import { Link, NavLink } from 'react-router-dom';
import Account from './components/Account/Account';
import { t } from 'utils';
import styles from './NavBar.module.scss';

const NavBar: FC = () => {
  return (
    <header className={styles.root}>
      <div className={styles.container}>
        <nav className={styles.row}>
          <Link className={styles.homeLink} to={routesByName.apps.index}>
            <TimifyLogo className={styles.logo} width='50px' height='50px' />
          </Link>
          <div className={styles['tabs-avatar']}>
            <ul className={styles.navList}>
              <li className={styles.navItem}>
                <NavLink
                  className={styles.navLink}
                  to={routesByName.apps.index}
                  activeClassName={styles.active}
                  isActive={(match, location) => {
                    if (!match) return false;
                    return match.isExact || location.pathname.includes('app');
                  }}
                >
                  {t('apps')}
                </NavLink>
              </li>
              <li className={styles.navItem}>
                <a
                  className={styles.navLink}
                  href={routesByName.documentation}
                  target='_blank'
                  rel='noreferrer'
                >
                  {t('documentation')}
                </a>
              </li>
              <li className={styles.navItem}>
                <a
                  className={styles.navLink}
                  href={routesByName.apiReference}
                  target='_blank'
                  rel='noreferrer'
                >
                  {t('api.reference')}
                </a>
              </li>
            </ul>
            <Account className='ml-2' />
          </div>
        </nav>
      </div>
    </header>
  );
};

export default NavBar;
